<div class="row">
  <p class="text-center"><small>{{ 'Version' }}: {{ version }}</small></p>
</div>
